import { render, staticRenderFns } from "./IconCheckSmall.vue?vue&type=template&id=d4a6edb6&"
import script from "./IconCheckSmall.vue?vue&type=script&lang=js&"
export * from "./IconCheckSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4a6edb6')) {
      api.createRecord('d4a6edb6', component.options)
    } else {
      api.reload('d4a6edb6', component.options)
    }
    module.hot.accept("./IconCheckSmall.vue?vue&type=template&id=d4a6edb6&", function () {
      api.rerender('d4a6edb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCheckSmall.vue"
export default component.exports